import { getField, updateField } from 'vuex-map-fields'
import getDirectPlacementFiltersModel from './models/directPlacementFilters'

const directPlacementFilters = {
  namespaced: true,
  state: {
    ...getDirectPlacementFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      return state
    }
  },
  actions: {
    clearFilters ({ commit }) {
      return commit('clearFilters')
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      state.clientId = null
      state.employeeName = null
      state.jobTitle = null
      state.isPaidInFull = null
    }
  }
}

export default directPlacementFilters
